import { Branded }		from "ts-base/branded";
import { Numbers }		from "ts-base/numbers";
import { Equal }		from "ts-base/equal";
import { Comparator }	from "ts-base/comparator";
import { Monoid }		from "ts-base/monoid";
import { Group }		from "ts-base/group";
import { Numeric }		from "ts-base/numeric/numeric";
import { Fin }			from "ts-base/numeric/fin";
// import { Int }			from "ts-base/numeric/int";
import { Nat }			from "ts-base/numeric/nat";
import { Pos }			from "ts-base/numeric/pos";

/** whole number */
export type Int	= Branded<number, "Int">;

export namespace Int {
	export const name		= "Int";

	export const brand		= Branded.brand<Int>;
	export const is			= (it:number):it is Int	=> Number.isInteger(it) && !Object.is(it, -0);

	export const fromNumber	= (it:number):Int|null	=> is(it) ? brand(it) : null;
	export const toNumber	= (it:Int):number		=> it;

	export const fromFin	= (it:Fin):Int|null	=> is(it)	? brand(it) : null;
	export const fromInt	= (it:Int):Int		=> it;
	export const fromNat	= (it:Nat):Int		=> brand(it);
	export const fromPos	= (it:Pos):Int		=> brand(it);

	export const zero		= brand(0);
	export const one		= brand(1);

	// eslint-disable-next-line @typescript-eslint/no-unsafe-unary-minus
	export const negate		= (it:Int):Int			=> brand(-it);
	export const add		= (a:Int, b:Int):Int	=> brand(a + b);
	export const subtract	= (a:Int, b:Int):Int	=> brand(a - b);
	export const multiply	= (a:Int, b:Int):Int	=> brand(a * b);

	export const increment	= (it:Int):Int	=> add(it, one);
	export const decrement	= (it:Int):Int	=> subtract(it, one);

	export const minimum	= brand(Number.MIN_SAFE_INTEGER);
	export const maximum	= brand(Number.MAX_SAFE_INTEGER);

	export const equal:Equal<Int>			= Numbers.equal;
	export const compare:Comparator<Int>	= Numbers.compare;
	export const sum:Group<Int>				= { empty: zero,	concat: add,		inverse: negate,	concatInverse: subtract	};
	export const product:Monoid<Int>		= { empty: one,		concat: multiply	};
}

// just for type checking
Numeric.typed(Int);
